import React, { useState } from "react";
import { Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import "../../molecules/BrandModal.css";

export const RejectModal = ({ toggle, setToggle, onReject, accountId }) => {
  const [reason, setReason] = useState("");
  const [showError, setShowError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const close = () => {
    setToggle(false);
    setReason("");
    setShowError(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!reason.trim()) {
      setShowError(true);
      return;
    }

    setSubmitting(true);
    try {
      await onReject(accountId, reason);
      close();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal isOpen={toggle} toggle={close} className="brand-modal">
      <ModalHeader toggle={close}>Reject Account</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">Please provide a justification for rejecting this account.</p>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="rejectReason">Justification</Label>
            <Input
              type="textarea"
              id="rejectReason"
              placeholder="Justification text that will be included in email"
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                if (e.target.value.trim()) setShowError(false);
              }}
            />
            {showError && <p className="text-danger">Required</p>}
          </FormGroup>

          <div className="brand-modal__actions">
            <button type="submit" className="brand-modal__btn brand-modal__btn--danger" disabled={submitting}>
              <FontAwesomeIcon icon={faTimesCircle} /> {submitting ? "Rejecting…" : "Reject"}
            </button>
            <button type="button" className="brand-modal__btn brand-modal__btn--cancel" onClick={close} disabled={submitting}>
              <FontAwesomeIcon icon={faTimes} /> Close
            </button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};
